<template>
    <div>
        <div class="name">
            <span>Имя камеры: {{cameraName}} <br> Название камеры: {{cameraTitle}} <br> Владелец камеры: {{cameraOwner}}</span>
            <span class="btn waves-effect waves-light indigo lighten-1 hoverable small right main"
                  v-if="!dvr"
                  @click="setOtherVideo(true, createDvrSrc)">archive
					</span>
            <span class="btn waves-effect waves-light indigo lighten-1 hoverable small right main"
                  v-else
                  @click="setOtherVideo(false, createDefaultSrc)">online</span>
        </div>
        <div class="cameras"
             style="position:relative;"
             :data-url="createVideoUrl">
            <div ref="cameras"
                 style="height: 100%;"
                 class="container-camera"></div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "FlussonicEmbedPlayer",
        props: {
            cameraToken: String,
            cameraName: String,
            cameraTitle: String,
            cameraOwner: String,
            cameraStreamer: String,
            httpsEnabled: Boolean,
            cameraAutoPlay: Boolean
        },
        data() {
            return {
                dvr: false,
                element: null,
                renderingEnable: false
            };
        },
        mounted() {
            console.log("httpsEnabled");
            console.log(this.httpsEnabled);
            this.createFrame();
        },
        methods: {
            // создание фрейма с видео
            createFrame() {

                this.element = document.createElement("iframe");
                this.element.setAttribute("allowfullscreen", "");

                this.element.src = `${this.createVideoUrl}${this.createDefaultSrc}${this.cameraToken}`;

                this.$refs.cameras.appendChild(this.element);

                this.addEventForFrame(this.element, "load", this.afterLoadFrame);
            },
            // задаем отображение кнопки архива и меняем адрес
            setOtherVideo(button, dvr) {
                this.dvr = button;
                this.$refs.cameras.classList.remove("show");
                this.element.src = `${this.createVideoUrl}${dvr}${this.cameraToken}`
            },
            // метод после закрузки фрейма с видео
            afterLoadFrame() {
                if (this.$refs.cameras) {
                    this.element.style =
                        "width: 100%; " +
                        "height: 100%; " +
                        "border: 1px solid rgba(75, 0, 130, 0.2);";
                    this.$refs.cameras.classList.add("show");
                }
            },
            // задаем собитие для фрейма
            addEventForFrame(elem, type, handler) {
                if (elem.addEventListener) {
                    elem.addEventListener(type, handler, false);
                } else {
                    elem.attachEvent("on" + type, () => {
                        handler();
                    });
                }
                return false;
            },

        },
        computed: {
            createVideoUrl: function () {
                if (this.httpsEnabled === true) {
                    return 'https://' + this.cameraStreamer + '/' + this.cameraName + '/embed.html';
                } else {
                    return 'http://' + this.cameraStreamer + '/' + this.cameraName + '/embed.html';
                }
            },
            createDefaultSrc: function () {
                if (this.cameraAutoPlay === true) {
                    return "?autoplay=true&ago=604800&token=";
                } else {
                    return "?autoplay=false&ago=604800&token=";
                }
            },
            createDvrSrc: function () {
                if (this.cameraAutoPlay === true) {
                    return "?autoplay=true&dvr=true&ago=604800&token=";
                } else {
                    return "?autoplay=false&dvr=true&ago=604800&token=";
                }
            }
        },

    };
</script>
<style scoped lang="scss">
    .main {
        text-transform: lowercase;
        padding: 0 10px;
        margin: 1px 1px 2px 5px;
        width: 80px;
    }

    .container-camera {
        opacity: 0;
    }

    .show {
        animation: opacity 3s forwards;
    }

    .in-flex {
        .name {
            padding: 15px 0 15px 0;
        }
    }

    @keyframes opacity {
        100% {
            opacity: 1;
        }
    }

    .cameras {
        @media screen and (min-width: 1000px) {
            width: 100%;
            height: 600px;
        }
        @media screen and (min-width: 1400px) {
            width: 100%;
            height: 750px;
        }
        @media screen and (max-width: 1400px) {
            width: 100%;
            height: 500px;
        }
        @media screen and (max-width: 1000px) {
            width: 100%;
            height: 680px;
        }
        @media screen and (max-width: 600px) {
            width: 100%;
            height: 600px;
        }
        @media screen and (max-width: 450px) {
            width: 100%;
            height: 460px;
        }
        @media screen and (max-width: 320px) {
            width: 280px;
            height: 300px;
        }
    }

    .preloader-enter-active {
        transition: all 0.2s ease;
    }

    .preloader-leave-active {
        transition: all 3s ease;
    }

    .preloader-enter, .preloader-leave-to {
        opacity: 0;
    }
</style>
